import React, { useCallback, useEffect, useState } from "react";
import { FaFire, FaHome, FaUser, FaMeetup } from "react-icons/fa";
import { TbCalendarEvent, TbNewSection } from "react-icons/tb";
import { MdChat, MdGroup } from "react-icons/md";
import { BsMenuApp } from "react-icons/bs";
import MobileMenu from "../../molecules/MobileMenu/Mobile.menu";
import { useAppSelector } from "../../../redux/ReduxType";

interface SidebarMobileProps {
  isDark: boolean;
  currentSelection: string;
  menu: (path: string) => void;
}

const SidebarMobile = ({ currentSelection, menu }: SidebarMobileProps) => {
  const [currentView, setCurrentView] = useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isDark = useAppSelector((state) => state.theme.isDark);

  const menuData = [
    {
      Title: "Home",
      Logo: <FaHome className="w-6 h-6" />,
      link: "",
    },
    {
      Title: "Reel",
      Logo: <FaFire className="w-6 h-6" />,
      link: "reel",
    },
    {
      Title: "Chat",
      Logo: <MdChat className="w-6 h-6" />,
      link: "chat",
    },
    {
      Title: "Profile",
      Logo: <FaUser className="w-6 h-6" />,
      link: "profile",
    },
    {
      Title: "Meeting",
      Logo: <FaMeetup className="w-6 h-6" />,
      link: "meet",
    },
    {
      Title: "Planner",
      Logo: <TbCalendarEvent className="w-6 h-6" />,
      link: "plan",
    },
    {
      Title: "News",
      Logo: <TbNewSection className="w-6 h-6" />,
      link: "news",
    },
    {
      Title: "Live",
      Logo: <MdGroup className="w-6 h-6" />,
      link: "live",
    },
  ];

  const ITEMS_PER_VIEW = 4;

  const filterList = useCallback(() => {
    const menuLength = menuData.length;
    const nextIndex = (currentIndex + ITEMS_PER_VIEW) % menuLength;
    setCurrentIndex(nextIndex);
    const endIndex = nextIndex + ITEMS_PER_VIEW;
    const newList = menuData.slice(nextIndex, endIndex);
    if (newList.length < ITEMS_PER_VIEW) {
      const remainingItems = ITEMS_PER_VIEW - newList.length;
      newList.push(...menuData.slice(0, remainingItems));
    }
    setCurrentView(newList);
  }, [currentIndex]);

  useEffect(() => {
    const initialList = menuData.slice(0, ITEMS_PER_VIEW);
    setCurrentView(initialList);
  }, []);

  return (
    <nav
      className={`fixed bottom-0 left-0 w-full flex items-center justify-around py-2 border-t shadow-sm ${
        isDark
          ? "bg-gray-800 border-gray-700 text-white"
          : "bg-white border-gray-200 text-gray-900"
      }`}
    >
      {currentView.map((item: any, index: number) => (
        <MobileMenu
          key={`${item.Title}-${index}`}
          Title={item.Title}
          Logo={item.Logo}
          link={item.link}
          isDark={isDark}
          isActive={currentSelection === item.link}
          onClick={() => menu(item.link)}
        />
      ))}
      <button
        onClick={filterList}
        className={`flex flex-col items-center w-12 py-1 rounded-md ${
          isDark
            ? "text-gray-300 hover:bg-gray-700 hover:text-white"
            : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
        } transition-colors duration-200`}
      >
        <BsMenuApp className="w-6 h-6" />
        <span className="text-xs">More</span>
      </button>
    </nav>
  );
};

export default SidebarMobile;
